import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApoioService {
  public params = new HttpParams();

  constructor(private readonly apiService: ApiService) { }

  // listar apoios
  list(params?: any): Observable<any> {
    return this.apiService.get(`/Apoio`, params ? new HttpParams({
      fromObject: params
    }) : this.params,
    ).pipe(
      map(response => response)
    );
  }

  /**
   * Obtém o total arrecadado consolidado de apoios confirmados (EstadoApoioENUM = 2).
   * Busca os apoios confirmados e soma o valorDoadoTotal (ou valorApoio).
   */
  getTotalApoiosConfirmados(): Observable<{ totalValor: number; totalApoios: number }> {
    const params = {
      PageNumber: 1,
      PageSize: 2000,
      EstadoApoioENUM: 2,
    };

    return this.list(params).pipe(
      map((res: any) => {
        const apoios: any[] = res?.data || [];
        const totalApoios = res?.totalRecords ?? apoios.length;

        const totalValor = apoios.reduce((acc: number, item: any) => {
          const valor = Number(item?.valorDoadoTotal ?? item?.valorApoio ?? 0) || 0;
          return acc + valor;
        }, 0);

        return {
          totalValor,
          totalApoios,
        };
      })
    );
  }

  show(id: string): Observable<any> {
    return this.apiService.get(
      `/Apoio/${id}`,
    ).pipe(
      map(response => response)
    );
  }

  /**
* Cria um novo apoio
* @param apoio
* @returns Observable<any>
*/
  public store(apoio: any): Observable<any> {
    return this.apiService.post(`/Apoio`, apoio);
  }

  consultarSaldoUser(userID: string): Observable<any> {
    return this.apiService.post(`/Apoio/SaldoDisponivel/${userID}`,
    ).pipe(
      map(response => response)
    );
  }

  apoioManual(apoio: any): Observable<any> {
    return this.apiService.post(`/Apoio/ApoioManual`, apoio
    ).pipe(
      map(response => response)
    );
  }
}